import { createMoment } from './create'
import { readMoments } from './read'

export const moments = {
  create: createMoment,
  read: readMoments,
}

export type {
  CreateMomentV2RequestBody,
  CreateMomentV2ResponseData,
} from './create'
